"use client"

import { Button } from "@/components/ui/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { useLanguage } from "@/contexts/language-context"
import { languages, type Language } from "@/lib/i18n"
import { Globe, ChevronDown } from "lucide-react"

export function LanguageToggle() {
  const { language, setLanguage } = useLanguage()
  const currentLanguage = languages[language]

  const handleLanguageChange = (newLanguage: Language) => {
    console.log(`语言切换: ${language} -> ${newLanguage}`)
    setLanguage(newLanguage)
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="h-9 px-3 gap-2 min-w-[100px]">
          <Globe className="h-4 w-4" />
          <span className="text-sm font-medium">
            {currentLanguage.code} {currentLanguage.name}
          </span>
          <ChevronDown className="h-3 w-3 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px]">
        {Object.entries(languages).map(([code, { name, flag, code: countryCode }]) => (
          <DropdownMenuItem
            key={code}
            onClick={() => handleLanguageChange(code as Language)}
            className={`cursor-pointer flex items-center gap-3 ${language === code ? "bg-accent" : ""}`}
          >
            <span className="font-medium text-muted-foreground text-xs min-w-[24px]">{countryCode}</span>
            <span className="text-sm">{name}</span>
            {language === code && <span className="ml-auto text-xs text-primary">✓</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
